// ** Initial State
const initialState = {
  data: []
}

const imports = (state = initialState, action) => {
  switch (action.type) {
    case 'IMPORTUSERDATA':
      return { ...state,data: action.data }
    default:
      return { ...state }
  }
}
export default imports
